import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { TokenProviderService } from './util-token-provider/token-provider.service';

function initialiseTokenProvider(tokenProviderService: TokenProviderService) {
  return () => tokenProviderService.initialise();
}

export function provideRmaTokenProvider(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      const initializerFn = initialiseTokenProvider(inject(TokenProviderService));
      return initializerFn();
    }),
  ]);
}
